import { Injectable } from "@angular/core";
import { CallNumber } from "@ionic-native/call-number";
import { Diagnostic } from "@ionic-native/diagnostic";
import { Platform } from "ionic-angular";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { GDAuthInterface } from '../../../model/gd-auth';
import { AlertServiceProvider } from "../../../providers/alert-service/alert-service";
import { FileUploaderProvider, OptionsUploadWithHttp } from '../../../providers/file-uploader/file-uploader';
import { PermissionCheckProvider } from "../../../providers/permission-check/permission-check";
import { RequestCloseCaseDto, RequestSendReportDto } from "../../../shared/nestjs/gd-only/dto/panic.dto";
import { EmergencyContactApi } from "../../../shared/nestjs/gd-only/services/emergency-contact.api";
import { PanicApi } from "../../../shared/nestjs/gd-only/services/panic.api";
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { AppPreferences } from './../../../shared/local/app-preferences.local';
@Injectable()
export class PanicBloc {

  private subscriptions: Array<Subscription> = [];

  constructor(
    public nestApiProvider: NestApiProvider,
    private appPreferences: AppPreferences,
    private panicApi: PanicApi,
    private emergencyContactApi: EmergencyContactApi,
    private platform: Platform,
    private alertService: AlertServiceProvider,
    private permissionCheckProvider: PermissionCheckProvider,
    private diagnostic: Diagnostic,
    private callNumber: CallNumber,
    private fileUploaderProvider: FileUploaderProvider,
  ) {

  }

  dispose() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  getAllCategories() {
    return new Promise<Array<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.panicApi.getAllCategories()
          .pipe(map(res => res.data))
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  getAllContact() {
    return new Promise<Array<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.emergencyContactApi.getContact()
          .pipe(map(res => res.data))
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  getHistories() {
    return new Promise<Array<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.panicApi.getHistories()
          .pipe(map(res => res.data))
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  closeCase(payload: RequestCloseCaseDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.panicApi.closeCase(payload)
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  sendReport(payload: RequestSendReportDto) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.panicApi.sendReport(payload)
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  getGeolocation() {
    return new Promise<{ latitude: any, longitude: any }>(async (resolve) => {
      let geolocation = { latitude: 0, longitude: 0 };

      const auth = await this.appPreferences.getAuth();
      if (auth.menu["panicbutton-web"] && !this.platform.is('cordova')) {
        geolocation = {
          latitude: -6.2841055,
          longitude: 106.723543
        };
        resolve(geolocation);
      } else {
        try {
          let position = await this.permissionCheckProvider.getGeolocation();
          if (position.coords.latitude && position.coords.longitude) {
            geolocation = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            };
            resolve(geolocation);
          } else {
            const confirm = await this.alertService.confirmMola('Error Getting Location', 'Skip', 'Try Again');
            if (confirm) {
              const response = await this.getGeolocation();
              resolve(response);
            }
            else {
              resolve(geolocation);
            }
          }
        }
        catch (error) {
          if (error.code === 99) {
            const confirm = await this.alertService.createMola(error.message);
            if (confirm && error.code === 99) {
              if (this.platform.is('ios')) {
                this.diagnostic.switchToSettings();
              } else {
                this.diagnostic.switchToLocationSettings();
              }
            }
            resolve(geolocation);
          } else {
            const confirm = await this.alertService.confirmMola((error.message == 'Timeout expired') ? 'Error Getting Location' : error.message, 'Skip', 'Try Again');
            if (confirm) {
              const response = await this.getGeolocation();
              resolve(response);
            }
            else {
              resolve(geolocation);
            }
          }
        }
      }
    })
  }

  phoneCall(phoneNumber) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.callNumber.isCallSupported();
        await this.callNumber.callNumber(phoneNumber, true);
        resolve(true)
      }
      catch (error) {
        reject(error)
      }
    })
  }

  uploadMultiple(files: any[], auth: GDAuthInterface) {
    return new Promise<string[]>(async(resolve, reject) => {
      try{
        const path = await this.panicApi.uploadUrl();
        console.log('path',path)
        const options:OptionsUploadWithHttp = {
          nativeURI: files,
          eventsWebview: null,
          type: 'image',
          options: null
        }

        const upload = await this.fileUploaderProvider.uploadMultipleWithHttp(options, path);
        resolve(upload);
      }
      catch(error){
        reject(error)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/bloc/feature/panic/panic.bloc.ts